/*
  NO FUGAZI — motion for the process and story stills.

  Every one of these was an animated GIF. Shopify does not transcode animated
  GIFs, so it shipped them whole: one 800x800 tile cost 540KB on a phone. They
  are now static JPEGs, which Shopify resizes and serves as WebP (~45KB), and
  this file layers the motion back on top as MP4 (~27-54KB) for anyone whose
  browser and preferences want it.

  Deliberate behaviour:
    - The <img> is never removed. It stays as the poster and the fallback, so
      the page still looks right with JS off, on a slow connection, or if the
      video 404s. Nothing here is required for the page to be correct.
    - Video is only fetched when the tile is close to the viewport, and only
      plays while it is actually on screen. Off-screen tiles are paused, which
      is the whole point of doing this rather than autoplaying seven at once.
    - prefers-reduced-motion is honoured by not swapping at all.
    - The video is inert: no controls, no fullscreen, no picture-in-picture,
      no context menu, pointer-events:none. It behaves like a GIF and cannot
      be interacted with, which is stricter than a GIF (you cannot even
      right-click save it).
*/
(function () {
  'use strict';

  var mapEl = document.getElementById('nf-motion-map');
  if (!mapEl) return;

  var MAP;
  try { MAP = JSON.parse(mapEl.textContent); } catch (e) { return; }
  if (!MAP || !Object.keys(MAP).length) return;

  // Motion is opt-out at the OS level. Respect it and leave the stills alone.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  // A phone on a metered or slow connection gets the still. It is already good.
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn && (conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

  var STYLE_ID = 'nf-motion-style';
  if (!document.getElementById(STYLE_ID)) {
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent =
      '.nf-motion-host{position:relative}' +
      '.nf-motion-vid{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;' +
      'pointer-events:none;opacity:0;transition:opacity .35s ease;z-index:1;background:transparent}' +
      '.nf-motion-vid.is-live{opacity:1}';
    document.head.appendChild(st);
  }

  function fileKey(url) {
    if (!url) return null;
    var clean = url.split('?')[0].split('#')[0];
    var name = clean.substring(clean.lastIndexOf('/') + 1);
    return Object.prototype.hasOwnProperty.call(MAP, name) ? name : null;
  }

  function srcOf(img) {
    return img.getAttribute('data-src') || img.getAttribute('src') || img.currentSrc || '';
  }

  var wired = new WeakSet();

  function wire(img) {
    if (wired.has(img)) return;
    var key = fileKey(srcOf(img));
    if (!key) return;
    wired.add(img);

    var host = img.parentElement;
    if (!host) return;
    host.classList.add('nf-motion-host');

    var vid = document.createElement('video');
    vid.className = 'nf-motion-vid';
    vid.muted = true;
    vid.defaultMuted = true;
    vid.loop = true;
    vid.autoplay = false;          // playback is driven by the observer, not the browser
    vid.playsInline = true;
    vid.setAttribute('muted', '');
    vid.setAttribute('loop', '');
    vid.setAttribute('playsinline', '');
    vid.setAttribute('webkit-playsinline', '');
    vid.setAttribute('disablepictureinpicture', '');
    vid.setAttribute('disableremoteplayback', '');
    vid.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback nofullscreen');
    vid.setAttribute('preload', 'none');
    vid.setAttribute('aria-hidden', 'true');
    vid.setAttribute('tabindex', '-1');
    vid.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    // If it cannot play for any reason, drop it and leave the still showing.
    vid.addEventListener('error', function () {
      vid.classList.remove('is-live');
      if (vid.parentElement) vid.parentElement.removeChild(vid);
    });
    vid.addEventListener('playing', function () { vid.classList.add('is-live'); });

    host.appendChild(vid);
    // Observe the IMG, not the video. The video is position:absolute inside the
    // host, so on a host that has not been laid out yet it reports a zero-size
    // rect and IntersectionObserver never fires. The img always has real layout.
    img.__nfVid = vid;
    vid.__nfSrc = MAP[key];
    OBS.observe(img);
    LOADER.observe(img);
  }

  // Fetch the file before it is nearly on screen. At 300px the clip started
  // downloading barely a scroll-flick ahead of appearing, so on a phone you met
  // the still and then watched it turn into motion. 900px is roughly a screen
  // of warning, which is the difference between "loading" and "already there".
  var LOADER = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var v = en.target.__nfVid;
      LOADER.unobserve(en.target);
      if (!v || v.getAttribute('src')) return;
      v.setAttribute('src', v.__nfSrc);
      v.load();
    });
  }, { rootMargin: '900px 0px' });

  // Play only while actually visible. Off-screen tiles are paused, not buffering.
  var OBS = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target.__nfVid;
      if (!v) return;
      if (en.isIntersecting) {
        if (!v.getAttribute('src')) { v.setAttribute('src', v.__nfSrc); v.load(); }
        var p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () { /* autoplay refused: the still stays, which is fine */ });
        }
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { threshold: 0.2 });

  function scan(root) {
    var imgs = (root || document).querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) wire(imgs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  // The theme swaps lazy images in late and re-renders sections in the editor.
  window.addEventListener('load', function () { scan(document); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
